<!-- Filtros para estados -->
<div style="margin-bottom: 16px;" class="filters">
    <mat-form-field appearance="outline" style="width: 250px;">
        <mat-label>Estado</mat-label>
        <mat-select [formControl]="statusFilter" multiple>
            @for (status of statusList; track status.value) {
            <mat-option [value]="status.value">{{ status.label }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" style="width: 250px;">
        <mat-label>Tipo</mat-label>
        <mat-select [formControl]="typeFilter" multiple>
            @for (type of typeList; track type.value) {
            <mat-option [value]="type.value">{{ type.label }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
</div>

<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <!-- Columna de Tipo -->
    <ng-container matColumnDef="request_type">
        <th mat-header-cell *matHeaderCellDef>
            TIPO
        </th>
        <td mat-cell *matCellDef="let element">
            <span style="font-size: 16px;">{{ getRequestTypeDisplay(element.request_type) }}</span>
        </td>
    </ng-container>

    <!-- Columna de Estado -->
    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
            ESTADO
        </th>
        <td mat-cell *matCellDef="let element">
            @if (element.status == 'approved') {
            <button mat-flat-button id="consumed">
                <mat-icon matTextPrefix>check_circle</mat-icon>
                <span style="font-size: 16px;">{{ getStatusDisplay(element.status) }}</span>
            </button>
            } @else if (element.status == 'rejected') {
            <button mat-flat-button id="non-consumed">
                <mat-icon matTextPrefix>cancelled</mat-icon>
                <span style="font-size: 16px;">{{ getStatusDisplay(element.status) }}</span>
            </button>
            } @else {
            <!-- cancelled -->
            <button mat-flat-button id="cancelled">
                <mat-icon matTextPrefix>person_cancel</mat-icon>
                <span style="font-size: 16px;">{{ getStatusDisplay(element.status) }}</span>
            </button>
            }

        </td>
    </ng-container>

    <!-- Columna de Fechas -->
    <ng-container matColumnDef="request_days">
        <th mat-header-cell *matHeaderCellDef>
            FECHAS
        </th>
        <td mat-cell *matCellDef="let element">
            <span class="utility-button" style="font-size: 16px;">{{ getRequestDaysDisplay(element) }}</span>
        </td>
    </ng-container>

    <!-- Columna de Acciones -->
    <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let element">
            <button mat-icon-button class="acciones" (click)="viewDetails(element)"
                [disabled]="!element.status_history || element.status_history.length === 0"
                matTooltip="Ver historial de cambios">
                <mat-icon>info_outline</mat-icon>
            </button>
        </td>
    </ng-container>

    <ng-container matColumnDef="reject">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
            <button
                mat-icon-button
                color="warn"
                [disabled]="element.status !== 'approved'"
                (click)="rejectPetition(element)"
                matTooltip="Rechazar petición">
                <mat-icon>highlight_off</mat-icon>
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

@if (dataSource.length === 0) {
<div style="padding: 20px; text-align: center;">
    <p>No hay peticiones anteriores</p>
</div>
}